import get from 'lodash/get';
import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
  recurringRulesTypes,
} from '../types';
import { initialRecurringRulesState } from '../states/recurringRules';

export default (state = initialRecurringRulesState, action) => {
  const resData = get(action, 'response.data') || {};
  switch (action.type) {
    // GET_RECURRING_RULES
    case asyncActionTypeRequest(recurringRulesTypes.GET_RECURRING_RULES): {
      return {
        ...state,
        recurringRules: {
          ...state.recurringRules,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(recurringRulesTypes.GET_RECURRING_RULES): {
      return {
        ...state,
        recurringRules: {
          loading: false,
          data: resData.data || resData || [],
          error: '',
          totalNo: resData.total || 0,
        },
      };
    }
    case asyncActionTypeFailure(recurringRulesTypes.GET_RECURRING_RULES): {
      return {
        ...state,
        recurringRules: {
          loading: false,
          data: [],
          error: action.payload,
          totalNo: 0,
        },
      };
    }

    // CREATE_RECURRING_RULE
    case asyncActionTypeRequest(recurringRulesTypes.CREATE_RECURRING_RULE): {
      return {
        ...state,
        createRecurringRule: {
          ...state.createRecurringRule,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(recurringRulesTypes.CREATE_RECURRING_RULE): {
      return {
        ...state,
        createRecurringRule: {
          loading: false,
          data: resData,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(recurringRulesTypes.CREATE_RECURRING_RULE): {
      return {
        ...state,
        createRecurringRule: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    }

    // UPDATE_RECURRING_RULE
    case asyncActionTypeRequest(recurringRulesTypes.UPDATE_RECURRING_RULE): {
      return {
        ...state,
        updateRecurringRule: {
          ...state.updateRecurringRule,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(recurringRulesTypes.UPDATE_RECURRING_RULE): {
      return {
        ...state,
        updateRecurringRule: {
          loading: false,
          data: resData,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(recurringRulesTypes.UPDATE_RECURRING_RULE): {
      return {
        ...state,
        updateRecurringRule: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    }

    // DELETE_RECURRING_RULE
    case asyncActionTypeRequest(recurringRulesTypes.DELETE_RECURRING_RULE): {
      return {
        ...state,
        deleteRecurringRule: {
          ...state.deleteRecurringRule,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(recurringRulesTypes.DELETE_RECURRING_RULE): {
      return {
        ...state,
        deleteRecurringRule: {
          loading: false,
          data: resData,
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(recurringRulesTypes.DELETE_RECURRING_RULE): {
      return {
        ...state,
        deleteRecurringRule: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    }

    // GET_AUTOMATED_ORDERS
    case asyncActionTypeRequest(recurringRulesTypes.GET_AUTOMATED_ORDERS): {
      return {
        ...state,
        automatedOrders: {
          ...state.automatedOrders,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(recurringRulesTypes.GET_AUTOMATED_ORDERS): {
      return {
        ...state,
        automatedOrders: {
          loading: false,
          data: resData.data || resData || [],
          error: '',
          totalNo: resData.total || 0,
        },
      };
    }
    case asyncActionTypeFailure(recurringRulesTypes.GET_AUTOMATED_ORDERS): {
      return {
        ...state,
        automatedOrders: {
          loading: false,
          data: [],
          error: action.payload,
          totalNo: 0,
        },
      };
    }

    default:
      return state;
  }
};
